import React from 'react'
import images from 'assets/img'
import { withTranslation } from 'react-i18next'

export default withTranslation()(function EmptyPOS({ t }) {
  return (
    <div className="w-full bg-white rounded-xl border border-border-lines p-8">
      <div className="w-full h-80 flex flex-col items-center justify-center">
        <div className="w-24 h-24 flex justify-center mb-7 items-center rounded-full bg-border-lines">
          <img src={images.Calculator} alt="" className="w-16 h-16" />
        </div>

        <p className="font-bold text-dark-blue mb-1">{t('pos.management.empty_title')}</p>
        <p className="text-placeholder">{t('pos.management.empty_hint')}</p>
      </div>
    </div>
  )
})
